// extracted by mini-css-extract-plugin
export default {"miniChat":"lb_lc","miniChat__supportingText":"lb_le","miniChat__messagesWrapper":"lb_lf","miniChat__message":"lb_lg","fadeOut":"lb_lh"};